import {IApiGameAccountDescription, IApiLeagueRestriction, IApiGameAccount} from "../typings/apiResponse";
import {GameAccountTypeService} from "./GameAccountTypeService";
import {GameAccountDescriptionResource} from "../resource/GameAccountDescriptionResource";
import {GameAccountResource} from "../resource/GameAccountResource";
import {GameAccountType} from "../league/GameAccountType";
import * as angular from "angular";
import {find} from "lodash";

export interface IGameAccountInfo {
    type: string;
    description: IApiGameAccountDescription;
    idProvider: string;
    value: string;
    readOnly: boolean;
}

export class GameAccountBuilder {

    public static $inject = ["GameAccountTypeService", "GameAccountDescriptionResource", "GameAccountResource", "$q"];
    constructor(
        private GameAccountTypeService: GameAccountTypeService,
        private GameAccountDescriptionResource: GameAccountDescriptionResource,
        private GameAccountResource: GameAccountResource,
        private $q: angular.IQService
    ) {}

    /**
     * Get game account objects by restrictions.
     *
     * @param restrictions
     */
    public getGameAccounts(restrictions: IApiLeagueRestriction[]): angular.IPromise<IGameAccountInfo[]> {
        const descriptionPromises = restrictions.map(restriction =>
            this.GameAccountDescriptionResource.getGameAccountDescription(restriction.params.type)
        );

        const providerPromises = restrictions.map(restriction =>
            this.GameAccountTypeService.getIdProvider(restriction.params.type));

        const userStatusPromises = restrictions.map(restriction =>
            this.GameAccountResource.getGameAccount(restriction.params.type).catch(() => null));

        return this.$q.all([
            this.$q.all(descriptionPromises as any),
            this.$q.all(providerPromises as any),
            this.$q.all(userStatusPromises as any)
        ]).then((response: any[]) => {
            const [descriptions, types, statuses] = response;

            return this.buildGameAccounts(restrictions, descriptions, types, statuses);
        }) as angular.IPromise<IGameAccountInfo[]>;
    }

    /**
     * Build game account object.
     *
     * @param restrictions
     * @param descriptions
     * @param gameAccountTypes
     * @param statuses
     */
    public buildGameAccounts(
        restrictions: IApiLeagueRestriction[],
        descriptions: IApiGameAccountDescription[],
        gameAccountTypes: GameAccountType[],
        statuses: IApiGameAccount[]
    ): IGameAccountInfo[] {
        return restrictions.map(restriction => {
            const type: string = restriction.params.type;
            const gameAccountType: GameAccountType = find(gameAccountTypes, gameAccountType => gameAccountType.getType() === type);
            const status: IApiGameAccount = find(statuses, (status: any) => (status && status.type) === type);
            const description: IApiGameAccountDescription = find(descriptions, description => description && description.type === type);
            const idProvider: string = gameAccountType ? gameAccountType.getIdProvider() : "";
            const value: string = status ? status.value : "";
            const readOnly: boolean = gameAccountType ? gameAccountType.getReadOnly() : false;

            return {
                type: type,
                description: description,
                idProvider: idProvider,
                value: value,
                readOnly: readOnly
            };
        });
    }
}
